import { deleteDoc, doc, serverTimestamp, setDoc } from "firebase/firestore"
import React from "react"
import { db } from "../../../../firebase/config"
import { Button, message, Popconfirm } from "antd"
import { FaTrash } from "react-icons/fa"
import { updateProductOrdersArray } from "../../../../utils/updateProductOrdersArray"

export default function DeleteOrder({ data, setOpen, icon = false }) {
  const deleteConfirm = async (e) => {
    e.preventDefault()

    const deletedOrderRef = doc(db, "deletedOrders", data.id)
    const orderRef = doc(db, "orders", data.id)

    try {
      // Add the document to deletedOrders with the same ID and a timestamp
      await setDoc(deletedOrderRef, {
        ...data,
        deletedAt: serverTimestamp(),
      })

      // Delete the order from the original orders collection
      await deleteDoc(orderRef)

      await updateProductOrdersArray("remove", data)

      message.success(`Deleted order ${data.orderNumber}`)
    } catch (err) {
      message.error("Creation Error: " + err.message)
    } finally {
      setOpen(false)
    }
  }
  return (
    <>
      <Popconfirm
        title="Delete order"
        okText="Yes"
        cancelText="No"
        description={`Are you sure to delete order ${data && data.orderNumber}?`}
        onConfirm={deleteConfirm}>
        {icon ? (
          <FaTrash color="red" style={{ cursor: "pointer" }} />
        ) : (
          <Button icon={<FaTrash />} block danger type="primary">
            Delete Order
          </Button>
        )}
      </Popconfirm>
    </>
  )
}
